module.exports = __webpack_public_path__ + "static/media/dashboard-subitem-icon.5d53d49e.svg";